export const MAP_CENTER = [37.536738, 55.74673];
export const MAP_OPTIONS = {
  ZOOM: 16.18,
  ROTATION: -30,
  PITCH: 30,
} as const;
export const MAP_RESTRICTIONS = {
  MAX_ZOOM: 22.1,
  MIN_ZOOM: 6,
} as const;
export const MAP_API_KEY = '7177f943-3df9-4a81-9916-65991a858cd8';
